export interface OptionsData {
  NextEarningsDate: string;
  Expirations: Expiration[];
  LastEarningsDate: string;
  symbol: string;
}

export interface Expiration {
  DaysToExpire: 3;
  OptionCycle: string;
  Puts: CallPut[];
  Calls: CallPut[];
  ExpirationDate: string;
}

export interface CallPut {
  ImpVol: number;
  Vega: number;
  BidDate: string;
  StrikePrice: number;
  Symbol: string;
  AskSize: number;
  Mid: number;
  Time: string;
  BidSize: number;
  Date: string;
  Theta: number;
  OpenInterest: number;
  AskDate: string;
  Gamma: number;
  Last: number;
  Volume: number;
  Delta: number;
  Ask: number;
  Rho: number;
  InTheMoney: boolean;
  AskTime: string;
  BidTime: string;
  Bid: number;
}

export async function fetchOptionsData(symbol: string): Promise<OptionsData> { // TODO: properly check this interface return
  let jsonLayerResponse;

  try {
    const response = await fetch('/json/api', {
      method: 'POST',
      body: new URLSearchParams({
        cmd: 'get-options',
        s: symbol
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });

    jsonLayerResponse = await response.json();

    window.sc3WorkbenchLogger.info('Fetch Options jsonLayerResponse.', jsonLayerResponse);
  } catch (e) {
    window.sc3WorkbenchLogger.error(`Failed to fetch options data for symbol: ${symbol}.`, e);

    throw new Error(`Failed to fetch options data for symbol: ${symbol}.`, { cause: e });
  }

  if (!jsonLayerResponse) {
    throw new Error(`Failed to fetch options data for symbol: ${symbol} - jsonLayerResponse is falsy: ${typeof jsonLayerResponse} ${jsonLayerResponse}.`);
  }

  if (typeof jsonLayerResponse !== 'object') {
    throw new Error(`Failed to fetch options data for symbol: ${symbol} - jsonLayerResponse is truthy but is not an object: ${typeof jsonLayerResponse}.`);
  }

  if (typeof jsonLayerResponse.success !== 'boolean') {
    throw new Error(`Failed to fetch options data for symbol: ${symbol} - jsonLayerResponse.success is not a boolean: ${typeof jsonLayerResponse.success}.`);
  }

  if (!jsonLayerResponse.success) {
    throw new Error(`Failed to fetch options data for symbol: ${symbol} - jsonLayerResponse.success is false.`);
  }

  if (!jsonLayerResponse.options) {
    throw new Error(`Failed to fetch options data for symbol: ${symbol} - jsonLayerResponse.options is falsy: ${typeof jsonLayerResponse.options} ${jsonLayerResponse.options}.`);
  }

  if (typeof jsonLayerResponse.options !== 'object') {
    throw new Error(`Failed to fetch options data for symbol: ${symbol} - jsonLayerResponse.options is truthy but is not an object: ${typeof jsonLayerResponse.options}.`);
  }

  if (!jsonLayerResponse.options.Expirations) {
    throw new Error(`Failed to fetch options data for symbol: ${symbol} - jsonLayerResponse.options.Expirations is falsy: ${typeof jsonLayerResponse.options.Expirations} ${jsonLayerResponse.options.Expirations}.`);
  }

  if (!Array.isArray(jsonLayerResponse.options.Expirations)) {
    throw new Error(`Failed to fetch options data for symbol: ${symbol} - jsonLayerResponse.options.Expirations is truthy but is not an array: ${typeof jsonLayerResponse.options.Expirations}.`);
  }

  return {
    ...jsonLayerResponse.options,
    symbol
  };
}
